<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  components: {
  },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    fromCheckin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      TableNumber: null
    };
  },
  async created() {
    this.initPriceTriggers(this.storeid);
  },
  mounted() {
    this.setStore(this.storeid);
    this.initStore(this.storeid);
    this.getStoreMenu(this.storeid);
    if (!sessionStorage.getItem("paymenttype")) {
      sessionStorage.setItem(
        "paymenttype",
        new URLSearchParams(window.location.search).get("paymenttype")
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let table = to.query.table || sessionStorage.getItem("table");
      if (!vm.fromCheckin) vm.setDineInDigitalDisplay(false);
      if (table) {
        vm.$data.TableNumber = table;
        sessionStorage.setItem("table", table);
        if (table == 0) {
          vm.setDineInDigitalDisplay(true);
        }
      }
    });
  },
  watch: {
    currentStoreDoc() {
      if(this.currentStoreDoc && this.TableNumber && this.isGuestCheckInEnabled && !localStorage.getItem("guestCheckinUser")) {
        this.guestCheckIn();
      } else if(this.currentStoreDoc) {
        this.orderNow()
      }
    },
  },
  computed: {
    ...mapGetters(["currentStoreDoc"]),
    isGuestCheckInEnabled() {
      return this.currentStoreDoc.EnableGuestCheckIn;
    },
  },
  methods: {
    ...mapMutations([
      "setStore",
      "setDineInDigitalDisplay",
      "setSelectedMenuType",
    ]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "initPriceTriggers"
    ]),
    orderNow(type) {
      this.setSelectedMenuType(type);
    },
    guestCheckIn() {
      this.$router.push({
        name: "guestCheckIn",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename
        },
        query: { table: this.TableNumber }
      });
    },
  }
};
</script>